import { writable } from 'svelte/store';

// -- VARIABLES

export let user = writable(
    {
        role: ""
    }
);
